import Axios from "axios";
import {baseURL, headers} from "@/axios/config";
import {md5} from "@/assets/javascript/MD5";
import {trim} from "core-js/internals/string-trim";
import router from "@/router";
// import {useRouter} from "vue-router";
// const router = useRouter()
const axios = Axios.create({
    baseURL, // 基础请求地址
    headers, // 设置请求头参数
    timeout: 30000, // 请求超时设置
    withCredentials: false, // 跨域请求是否需要携带 cookie
})

// 请求发出前的拦截开始
let timeData;
axios.interceptors.request.use(config => {
    // 设置 X-timestamp 值开始
    let xmlhttp;

    //创建xmlhttprequest对象
    function createXMLHttpRequest() {
        xmlhttp = new XMLHttpRequest();  //这里要判断IE的写法
    }

    function startRequest(url) {
        createXMLHttpRequest();
        xmlhttp.open("GET", url, false);  //true:异步，false:同步
        xmlhttp.onreadystatechange = handleStateChange;
        xmlhttp.send(null);
    }

    function handleStateChange() {
        if (xmlhttp.readyState === 4 && xmlhttp.status === 200) {
            const txt = xmlhttp.responseText;
            if (txt != null && txt !== "") {
                localStorage.setItem('MklTmKey', JSON.stringify({
                    serverTm: JSON.parse(txt).data.timestamp,
                    clientTm: Math.round(new Date().getTime() / 1000)
                }));
                config.headers['X-Timestamp'] = JSON.parse(localStorage.MklTmKey).serverTm
            }
        }
    }

    // if (!localStorage.MklTmKey || !trim(localStorage.MklTmKey) || Math.abs(Math.round(new Date().getTime() / 1000) - Number(JSON.parse(localStorage.MklTmKey).clientTm)) > 800) {
    //     localStorage.removeItem('MklTmKey')
    //     startRequest(baseURL + "/api/timestamp")
    // }
    // 请求时间戳设置头信息结束
    // 设置 X-timestamp 值结束

    // 判断设置头文件时间戳的值开始
    // if (config.headers['X-Timestamp'] === undefined || !config.headers['X-Timestamp']) {
    //     if (JSON.parse(localStorage.MklTmKey).serverTm) {
    //         config.headers['X-Timestamp'] = JSON.parse(localStorage.MklTmKey).serverTm
    //     } else {
    //         localStorage.removeItem('MklTmKey')
    //         startRequest(baseURL + "/api/timestamp")
    //     }
    // }
    // 判断设置头文件时间戳的值结束

    // 每次请求用最新 token（登录页刚写入 localStorage 后也能带到后续请求）
    config.headers['X-User-Token'] = localStorage.MklUserToken ? localStorage.MklUserToken : ''

    // 请求中英文MSDS修改参数开始
    if (config.params !== undefined && config.params.lang !== undefined) {
        config.headers['X-Language'] = config.params.lang
    }
    // 请求中英文MSDS修改参数结束

    // Excel上传批量加入购物车修改头文件开始
    if (config.url === '/api/quick/buy') {
        config.headers['Content-Type'] = 'multipart/form-data'
    }
    // Excel上传批量加入购物车修改头文件结束

    // 请求设置签名开始
    let bodyParam = null
    let time = Date.now() + Math.floor(Math.random()) + Math.ceil(Math.random())

    if (timeData) {
        const numArr = timeData.match(/\d+/g);
        time = Date.now() + (numArr.join(''))
    }
    if (config.method === 'get') {
        if (config.params === undefined) {
            config.params = {}
        }
        config.params['timestamp'] = time
        bodyParam = {...config.params}
    }
    if (config.method === 'post') {
        if (config.data === undefined) {
            config.data = {}
        }
        config.data['timestamp'] = time
        bodyParam = {...config.data}
    }
    if (config.method === 'put') {
        if (config.data === undefined) {
            config.data = {}
        }
        config.data['timestamp'] = time
        bodyParam = {...config.data}
    }
    if (config.method === 'delete') {
        if (config.params === undefined) {
            config.params = {}
        }
        config.params['timestamp'] = time
        bodyParam = {...config.params}
    }

    // 请求头参数设置
    let headersArrSorts = []
    Object.keys(config.headers).sort(function (s, t) {
        let a = s.toLowerCase();
        let b = t.toLowerCase();
        if (a < b) return -1;
        if (a > b) return 1;
        return 0;
    }).map(item => {
        if (item !== 'Content-Type' && config.headers[item] !== '' && config.headers[item] !== undefined && config.headers[item] !== null && !(config.headers[item] instanceof Object) && !(config.headers[item] instanceof Array)) {
            headersArrSorts.push(item + '=' + config.headers[item])
        }
    })
    let newHeadersString = (headersArrSorts.join('&') + '&salt=ndksyr9834@#$32ndsfu').toLowerCase()
    // 请求体参数设置
    let bodyParamArrSorts = []
    Object.keys(bodyParam).sort(function (s, t) {
        let a = s.toLowerCase();
        let b = t.toLowerCase();
        if (a < b) return -1;
        if (a > b) return 1;
        return 0;
    }).map(item => {
        if (bodyParam[item] !== '' && bodyParam[item] !== undefined && bodyParam[item] !== null && !(bodyParam[item] instanceof Object) && !(bodyParam[item] instanceof Array)) {
            if (trim(bodyParam[item])) {
                bodyParamArrSorts.push(item + '=' + trim(bodyParam[item]))
            }
        }
    })
    let newBodyParamString = (bodyParamArrSorts.join('&') + '&salt=ndksyr9834@#$32ndsfu').toLowerCase()
    // 转化MD5加密后设置到头参数
    config.headers['sign'] = md5(newHeadersString) + md5(newBodyParamString)
    // 记录请求前的签名参数
    // if (config.method === 'get') {
    //     config.params['s_s'] = encodeURIComponent(newBodyParamString)
    // }
    // if (config.method === 'post') {
    //     config.data['s_s'] = newBodyParamString
    // }
    // 请求设置签名结束

    timeData = config.headers['sign']
    return config
}, error => {
    console.log(error);
})
// 请求发出前的拦截结束
//
// 请求回来前的拦截开始
axios.interceptors.response.use(res => {
    if ( res.config.url !== '/api/user/info' && res.config.url !== '/api/product/stock') {
        if (res.data.code === 1005) {
            const currentPath = encodeURIComponent(router.currentRoute.value.fullPath);
            window.location.replace('/login?redirect=' + currentPath)
        }
    }else if (res.config.url === '/api/user/info') {
        if (res.data.code === 1005) {
            localStorage.removeItem('MklUserToken')
            localStorage.removeItem('MklUserInfo')
        }
    }

    // 请求回来如果是504时再请求时间戳接口开始
    let xmlhttps;

    //创建xmlhttprequest对象
    function createXMLHttpRequest() {
        xmlhttps = new XMLHttpRequest();  //这里要判断IE的写法
    }

    function startRequests(url) {
        createXMLHttpRequest();
        xmlhttps.open("GET", url, false);  //true:异步，false:同步
        xmlhttps.onreadystatechange = handleStateChanges;
        xmlhttps.send(null);
    }

    function handleStateChanges() {
        if (xmlhttps.readyState === 4 && xmlhttps.status === 200) {
            const txt = xmlhttps.responseText;
            if (txt != null && txt !== "") {
                localStorage.setItem('MklTmKey', JSON.stringify({
                    serverTm: JSON.parse(txt).data.timestamp,
                    clientTm: Math.round(new Date().getTime() / 1000)
                }));
                window.location.replace(window.location.href)
            }
        }
    }

    if (res.data.code === 504 && res.data.message === 'Signature expired') {
        localStorage.removeItem('MklTmKey')
        startRequests(baseURL + '/api/timestamp')
    }
    // 请求回来如果是504时再请求时间戳接口结束

    const {status, data, headers} = res
    // 判断响应的状态开始
    if (status >= 200 && status < 300 || status === 304) {
        return {data, headers}
    } else {
        throw res
    }
    // 判断响应的状态结束
}, error => {
    console.log(error);
})
// 请求回来前的拦截结束
export default axios;
